import { ACTIVITY_LOG_TRIGGER_LABELS } from '@biz2x/libraries/core-utils/utils';
/**
 * Interface for the 'AppState' data
 */
export interface AppStateEntity {
  loaded: boolean // has the AppState list been loaded
  error?: string | null // last known error (if any)
}

export const UTIL_TASKS: Record<number, string> = {
  ...ACTIVITY_LOG_TRIGGER_LABELS,
};
